import React from "react";
import { Container, Header, Tab, Icon, Menu, Label } from 'semantic-ui-react';
import noDataImage from "../../../images/common/no_data_image.svg";
import { dispatch } from '@rematch/core';
import FilterEvents from '../../workspace/home/Drive/Cards/FilterEvents'
import AccountNotification from './Notifications/AccountNotification';
import SystemNotification from './Notifications/SystemNotification';


class Notification extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            activeIndex: 0
        }
    }

    closeDock() {
        this.props.handleNotificationChange(false)
    }

    handleTabChange = (e, { activeIndex }) => this.setState({ activeIndex })

    render() {

        let windowHeight = window.innerHeight;
        // seen = notifications.length && notifications.filter((item) => { return item.seen === false });

        // let filteredNotification = this.props.allNotification &&
        //     this.props.allNotification.data && this.props.allNotification.data &&
        //     this.props.allNotification.data.length > 0 ?
        //     this.props.allNotification : null


        const { activeIndex } = this.state;
        const { selectedAccount, selectedOrganisation, allNotification, filterQuery } = this.props;

        const panes = [
            {
                menuItem: <Menu.Item key='Owner'>
                    Account <Label>{this.props.allNotification ? this.props.allNotification.total : 0}</Label>
                </Menu.Item>, render: () =>
                    <AccountNotification
                        filterQuery={filterQuery}
                        selectedAccount={selectedAccount}
                        allNotification={allNotification}
                        loadingNotifications={this.props.loadingNotifications} />
            },
            {
                menuItem: <Menu.Item key='Users'>
                    System <Label>0</Label>
                </Menu.Item>
                , render: () => <SystemNotification />
            }
        ]

        return (
            <React.Fragment >
                <h4 className="pane_header"> Notifications
                    <Icon name="close" className="closeNotificationIcon" onClick={() => this.closeDock()} />
                </h4>
                <div className="float-left w_100" >
                    <FilterEvents
                        selectedOrganisation={selectedOrganisation}
                        selectedAccount={selectedAccount}
                        type="notification"
                        filterQuery={filterQuery}
                    />
                </div>
                <div className="bg-light-blue float-left w_100" style={{ maxHeight: windowHeight - 85, minHeight: windowHeight - 87, overflow: "auto" }}>
                    <Tab
                        style={{ padding: 0 }}
                        menu={{ secondary: true, pointing: true }}
                        panes={panes}
                        activeIndex={activeIndex}
                        onTabChange={this.handleTabChange}
                        className="two-block" />
                </div>
            </React.Fragment>
        );
    }
}
export default Notification;
